module.exports = __webpack_public_path__ + "img/40th_nutfes_logo_black.a6008041.png";